module.exports = __webpack_public_path__ + "img/message-focus.9b402e41.svg";